module.exports = {"home":"Dashboard","report":"Report","linkages":"Linkages","monitoring":"Monitoring","distraints":"Distraints","portfolio":"Portfolio"}